const CODE_TYPES = {
  consumerUnitNumber: 'consumer_unit_number',
  installationCode: 'installation_code',
  both: 'consumer_unit_number_and_installation_code',
}

const showsConsumerUnitNumber = codeType =>
  [CODE_TYPES.consumerUnitNumber, CODE_TYPES.both].includes(codeType)

const showsInstallationCode = codeType =>
  [CODE_TYPES.installationCode, CODE_TYPES.both].includes(codeType)

const requiresEitherCode = codeType => codeType === CODE_TYPES.both

const energy = { showsConsumerUnitNumber, showsInstallationCode, requiresEitherCode }
export default energy
